import constants from "constants/constants";
import React from "react";
import { getUserCurrencySymbol } from "utils/AuthUtil";
import {
  CustomerEligibility,
  StatusField,
  ValidityField,
} from "./components/CustomColumns";
import { DISCOUNT_VAULE_1 } from "./discounts.constants";
import { formatRevenue } from "features/Common/utils/common.utils";

export const getDiscountValue = (record) =>
  record.type === DISCOUNT_VAULE_1
    ? `${record.value}%`
    : `${getUserCurrencySymbol(
        constants.CURRENCY_SYMBOL_MAP[record.currency]
      )} ${record.value}`;

export const columnConfig = ({ showValidityPopup, showEligibilityPopup }) => [
  {
    field: "code",
    headerName: "Discount Code",
    noWrap: true,
    sortable: false,
    fixed: "left",
  },
  {
    field: "applicability",
    headerName: "Validity",
    showInCard: true,
    valueFormatter: (record) => (
      <ValidityField record={record} showValidityPopup={showValidityPopup} />
    ),
    noWrap: true,
    sortable: false,
  },
  {
    field: "usage_count",
    headerName: "No. of times used",
    showInCard: true,
    noWrap: true,
    emptyField: "N/A",
    sortable: false,
  },
  {
    field: "usage_limit",
    headerName: "Usage Limit",
    noWrap: true,
    sortable: false,
  },
  {
    field: "applicability",
    headerName: "Customer eligibility",
    valueFormatter: (record) => (
      <CustomerEligibility
        record={record}
        showEligibilityPopup={showEligibilityPopup}
      />
    ),
    noWrap: true,
    sortable: false,
  },
  {
    field: "value",
    headerName: "Discount Value",
    showInCard: true,
    valueFormatter: (record) => <span>{getDiscountValue(record)}</span>,
    noWrap: true,
    sortable: false,
  },
  {
    field: "total_leads",
    headerName: "No. of leads",
    noWrap: true,
    emptyField: "N/A",
    sortable: false,
  },
  {
    field: "total_bookings",
    headerName: "No. of bookings",
    noWrap: true,
    emptyField: "N/A",
    sortable: false,
  },
  {
    field: "total_revenue",
    headerName: "Total revenue",
    noWrap: true,
    emptyField: "N/A",
    sortable: false,
    valueFormatter: (record) => formatRevenue(record?.total_revenue),
  },
  {
    field: "status",
    headerName: "Status",
    valueFormatter: (record) => <StatusField record={record} />,
    noWrap: true,
    sortable: false,
    hidden: true,
    fixed: "right",
  },
];
